import { createApp } from 'vue/dist/vue.esm-bundler';
import axios from 'axios';
import { enableBodyScroll } from 'body-scroll-lock';
import {getDistance} from 'geolib';

function addClass(el, className) {
  if (el.classList) el.classList.add(className);
}

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
}

export function closeSearch() {
  const body = document.querySelector('body');
  removeClass(body, 'isSearchOpen');
}

const eventHandler = () => {
  const el = document.querySelector('.js-header-search-opener');
  const searchResult = document.querySelector('[js-header="search-results"]');

  if (!el) {
    return;
  }

  el.addEventListener('click', () => {
    const body = document.querySelector('body');
    addClass(body, 'isSearchOpen');
    enableBodyScroll(searchResult);
  });
};

const headerInit = () => {
  const headerSearch = document.querySelector('#js-header-search');
  if (headerSearch) {
    const app = createApp({
      delimiters: ['${', '}'],
      data() {
        return {
          search: '',
          locationList: [],
          filteredList: [],
          previousSearchTime : null,
          state : 'ready',
          haveNearby : null
        };
      },
      methods: {
        setFocus() {
          const body = document.querySelector('body');
          const headerSearchInput = document.querySelector(
              '.js-header-search-input'
          );
          addClass(body, 'isSearchOpen');
          addClass(headerSearchInput, 'active');
        },
        blur() {
          const headerSearchInput = document.querySelector(
              '.js-header-search-input'
          );
          if (headerSearchInput.value) {
            addClass(headerSearchInput, 'active');
          } else {
            removeClass(headerSearchInput, 'active');
          }
        },
        closeSearch() {
          const body = document.querySelector('body');
          const searchResult = document.querySelector(
              '[js-header="search-results"]'
          );

          removeClass(body, 'isSearchOpen');
          enableBodyScroll(searchResult);
        },
        async getLatLong(address)
        {
          let encodedAddress = encodeURI(address.trim());

          let endpoint = '/actions/groupfirst/search/geocode';

          return await axios.post(endpoint, this.geocodeParams(encodedAddress));
        },
        geocodeParams(address) {
          var params = new URLSearchParams();

          params.append(window.csrfTokenName, window.csrfTokenValue);
          params.append('address', address);

          return params;
        },
        getClosestLocation(searchLocation)
        {
          let smallestDistance;
          let closestLocation;

          this.locationList.forEach((l) => {
            if(l.searchEnable === false) return;

            let siteLocation = {
              latitude : l.lat,
              longitude : l.long
            };

            let distance = getDistance(siteLocation, searchLocation);

            if(smallestDistance == null || distance < smallestDistance) {
              smallestDistance = distance;
              closestLocation = l;
            }
          });

          return closestLocation;
        },
          getClosestLocations(searchLocation, count = 3) {
              const enabledLocations = this.locationList.filter(l => l.searchEnable !== false);

              const locationsWithDistance = enabledLocations.map(l => {
                  const siteLocation = {
                      latitude: l.lat,
                      longitude: l.long
                  };
                  return {
                      location: l,
                      distance: getDistance(siteLocation, searchLocation)
                  };
              });

              locationsWithDistance.sort((a, b) => a.distance - b.distance);

              return locationsWithDistance.slice(0, count).map(ld => ld.location);
          },
        filterList() {
          const list = this.filteredList = this.locationList.filter(
              location =>
                  location.title
                      .toLowerCase()
                      .startsWith(this.search.toLowerCase()) ||
                  location.address
                      .toLowerCase()
                      .includes(this.search.toLowerCase()) ||
                  location.city.toLowerCase().startsWith(this.search.toLowerCase()) ||
                  location.postcode
                      .toLowerCase()
                      .startsWith(this.search.toLowerCase())
          );

          return list;
        },
        async initApiSearch() {
          this.state = 'loading';
          this.previousSearchTime = Date.now();
          let time = this.previousSearchTime;

          setTimeout(async () => {
            if(time !== this.previousSearchTime) {
              return;
            }

            let response = await this.getLatLong(this.search.toLowerCase());
            let searchLocation = response.data;

            if(searchLocation === null || searchLocation === '') {
              this.haveNearby = false;
              this.state = 'ready';
              return;
            }

            this.filteredList = this.getClosestLocations(searchLocation);

            this.haveNearby = true;
            this.state = 'ready';
          }, 750);
        }
      },
      watch : {
        search : async function() {
          this.haveNearby = null;

          this.filteredList = this.filterList();

          let searchable = this.filteredList.filter(l => l.searchEnable === true);

          if(searchable.length != 0 || this.search.length < 3) {
            return;
          }

          this.initApiSearch();
        }
      },
      created() {
        axios.get('/api/search').then(response => {
          this.locationList = response.data.data;
          this.filteredList = this.filterList();
        });
      }
    });

    app.mount(headerSearch);
  }
};

const headerSearch = async () => {
  eventHandler();
  headerInit();
};

export default headerSearch;
